/**
 * 知识类型列表功能
 * @Author:wuTao
 * @Date 2023/04/11
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';
import {knowledgeTypeExcelColumns} from './excelColumns'
import {component_tool, framework_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport} = component_tool;

class KnowledgeTypeList extends WizContainer {

  componentName = 'KnowledgeTypeList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = knowledgeTypeExcelColumns;
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '知识类型信息',
        sheetName: '知识类型信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '知识类型信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        updateState: this._handleCMD,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(KnowledgeTypeList);
